var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclaimedWithIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 10.8334C11.8805 10.8334 12.9998 9.71413 12.9998 8.33341C12.9998 6.9527 11.8805 5.83341 10.4998 5.83341C9.11913 5.83341 7.99984 6.9527 7.99984 8.33341M10.3435 13.5938H10.656M10.3435 13.9063H10.656M18.8332 10.0001C18.8332 14.6025 15.1022 18.3334 10.4998 18.3334C5.89746 18.3334 2.1665 14.6025 2.1665 10.0001C2.1665 5.39771 5.89746 1.66675 10.4998 1.66675C15.1022 1.66675 18.8332 5.39771 18.8332 10.0001ZM10.9165 13.7501C10.9165 13.9802 10.73 14.1667 10.4998 14.1667C10.2697 14.1667 10.0832 13.9802 10.0832 13.7501C10.0832 13.52 10.2697 13.3334 10.4998 13.3334C10.73 13.3334 10.9165 13.52 10.9165 13.7501Z",
    stroke: "#AAAAAA",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaimedWithIcon);
export default __webpack_public_path__ + "static/media/exclaimed_with_icon.e4e9880254e27f802c26ef12a05a03b2.svg";
export { ForwardRef as ReactComponent };